import type { SVGProps } from 'react';

export const ConfettiBg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='390'
      height='180'
      viewBox='0 0 390 180'
      fill='none'
      aria-hidden
      {...props}
    >
      <g opacity='.1'>
        <path fill='#fafafa' d='m15.868 176.269.897-6.081 24.363 3.731-.897 6.081z' />
        <path fill='#fafafa' d='m220.106 173.33-6.01-1.402 5.644-23.894 6.01 1.402z' />
        <path fill='#fafafa' d='m327.667 128.676-6.01 1.402 5.644 23.894 6.01-1.402z' />
        <path fill='#fafafa' d='m5.822 28.816-.982-6.058 24.377-3.902.981 6.058z' />
        <path fill='#fafafa' d='m164.351 165.997-1.726 7.458-22.376-5.316 1.726-7.457z' />
        <path fill='#f5f5f5' d='m338.032 101.065 4.721-6.026-18.186-14.08-4.72 6.027z' />
        <path fill='#fafafa' d='m260.786 51.236-5.835-4.968 14.994-17.402 5.835 4.968z' />
        <path fill='#f5f5f5' d='m279.454 147.408-.15 7.637-23.046-.447.15-7.637z' />
        <path fill='#fafafa' d='m387.015 154.598-.15-7.637-23.046.447.15 7.637z' />
        <path fill='#f5f5f5' d='m52.52 73.51-7.162 2.768-8.351-21.356 7.162-2.768z' />
        <path fill='#fafafa' d='M182.546-2.738 175.384.03l-8.352-21.356 7.162-2.768z' />
        <path fill='#f5f5f5' d='m327.602 15.67-7.162 2.767-8.352-21.356 7.162-2.768z' />
        <path fill='#fafafa' d='m130.666 114.922-7.648.45-1.489-22.933 7.648-.45z' />
        <path fill='#fafafa' d='m379.528 95.654 5.433 5.401 16.3-16.202-5.434-5.401z' />
        <path fill='#fafafa' d='m-5.161 89.054 7.092 2.94-8.873 21.148-7.092-2.94z' />
        <path fill='#fafafa' d='m96.687 12.356 7.091 2.94-8.873 21.148-7.091-2.94z' />
        <path fill='#f5f5f5' d='m216.028 9.654 7.092 2.94-8.873 21.148-7.092-2.94z' />
        <path fill='#fafafa' d='m244.19 94.744 5.433-5.4 16.3 16.202-5.434 5.4z' />
        <path fill='#f5f5f5' d='m54.864 137.033.082-7.657 22.988.382-.082 7.657z' />
        <path fill='#fafafa' d='m183.941 131.29-7.649-.724 2.187-22.81 7.649.725z' />
      </g>
    </svg>
  );
};
